export default __webpack_public_path__ + "static/media/lost.23732373.svg";